import { getData, putData } from "./rest-api-helper";


export async function getNotifyByUserServ() {
    const details = {
        urlPath: `/notify/byUser`
    }
    const res = await getData(details);
    return res.data;
}

export async function deleteNotifyByIdServ(notifyId) {
    const details = {
        urlPath: `/notify/deleteById/${notifyId}`
    }
    const res = await putData(details);
    return res;
}

export async function deleteNotifyByUserServ() {
    const details = {
        urlPath: `/notify/deleteByUser`
    }
    const res = await putData(details);
    return res;
}